import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, IconButton, InputBase, ListItem, makeStyles, NativeSelect, Typography, useTheme, withStyles } from '@material-ui/core'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { ArrowBack, Search } from '@material-ui/icons'
import { Loading, useDataProvider, useTranslate } from 'react-admin'
import { Link, useHistory } from 'react-router-dom'
import SaveLoading from '../common/loading-page'
import TextButton from '../CustomizedUIs/TextButton'
import GoBackButton from '../CustomizedUIs/GoBackButton'
const useStyles = makeStyles(theme => ({
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TextSearch: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#88898c',
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    TitleName: {
        fontFamily: ' UniviaPro',
        fontSize: ' 13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

}));

const FilterInput = ({ onChangeValue, value, name, open }) => {
    const classes = useStyles()
    const theme = useTheme()

    return (
        <Box display='flex' style={{ borderRadius: '8.1px', border: ' solid 0.8px #f1f2f4', backgroundColor: "#f7f7f7" }}>
            <Search style={{ color: '#b4b5bd', size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                autoFocus={open === true ? true : false}
                value={value}
                onChange={onChangeValue}
                placeholder={"Filter " + name}
                inputProps={{
                    'aria-label': 'search',
                    className: classes.TextSearch
                }}
                style={{ width: '180px' }}
            />
        </Box>
    )
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const KeyMap = (props) => {
    const history = useHistory()
    const [infoPage, setInfoPage] = useState({ name: '' })
    const [infoPages, setInfoPages] = useState([])
    const [filterInfoPage, setFilterInfoPage] = useState('')
    const [openIngoPage, setOpenInfoPage] = useState(false)
    const [node, setNode] = useState([])
    const [nodes, setNodes] = useState([])
    const [loading, setLoading] = useState(false)
    const [nodeLoading, setNodeLoading] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const theme = useTheme()
    const [name, setName] = useState('')
    const [keyData, setKeyData] = useState([])
    const translate = useTranslate()

    const pickInfoPage = (value) => {
        setInfoPage(value)
        setOpenInfoPage(false)
        if (value.id)
            getNodesApp(value.id)
        else
            setNodes([])
        setNode([])
    }

    const handleChange = (event, index) => {
        let temps = [...node]
        temps[index] = event.target.value
        setNode(temps);
    };

    const getInfopages = () => {
        setLoading(true)
        dataProvider('GET_LIST', "info-page-list", {
            filter: {},
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            setInfoPages(data)
            getRemote(data)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    const getNodesApp = (id) => {
        setNodeLoading(true)
        dataProvider('GET_ONE', "info-page/get-node-app", {
            id: id
        }).then(({ data }) => {
            setNodes(data)
            setNodeLoading(false)
        }).catch(error => {
            setNodeLoading(false)
        });
    }

    const getRemote = (infopages) => {
        !loading && setLoading(true)
        dataProvider('GET_ONE', "remotes", {
            id: parseInt(props.match.params.id)

        }).then(({ data }) => {
            setKeyData(data.keys)
            setName(data.name)
            let ifp = infopages.find(item => item.id === data.infopage)
            if (ifp) {
                getNodesApp(ifp.id)
                setInfoPage(ifp)
                let tempsNode = []
                data.keys.forEach((item, index) => {
                    tempsNode[index] = item.node
                })
                setNode(tempsNode)
            }
            setLoading(false)
        })
    }

    const onSave = () => {
        setLoadingSave(true)
        let temps = [...keyData]
        node.forEach((item, index) => {
            if (item)
                temps[index].code = item
        })
        dataProvider('UPDATE', "edit-maping", {
            id: parseInt(props.match.params.id),
            data: {
                infopage: infoPage.id,
                keys: temps,
            }
        }).then(response => {
            history.push({
                pathname: '/remote',
                state: { open: true, name: name, message: translate(`pos.categories.editFolder.success`) }
            });
            setLoadingSave(false)
        }).catch(error => {
            setLoadingSave(false)
        });
    }

    useEffect(() => {
        getInfopages()
    }, [])
    if (loading) return <Loading />
    return (
        <Box width='80%' m='auto'>
            <SaveLoading show={loadingSave} />
            <Box >
                <Box my={5} width={300} display='flex' component={Link} to={'/Remote'} style={{ textDecoration: 'none' }}>
                    <Box display='flex' mr={2}>
                       <GoBackButton/>
                    </Box>
                    <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.remoteControl.back`)}</Typography>
                </Box>
            </Box>
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    <Box display='flex' justifyContent='space-between'>
                        <Typography style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }} variant='h5'>{translate(`pos.remoteControl.mapping`) + ` ${name}`}</Typography>

                    </Box>
                    <Box my={2}>
                        <SelectBox
                            label={'Info page'}
                            value={!infoPage.id ? '' : <Typography className={classes.TextValue}>{infoPage.name}</Typography>}
                            open={openIngoPage}
                            handleClick={() => { setOpenInfoPage(!openIngoPage) }}
                        >
                            <ListItem className={classes.boxBoder} style={{ padding: '8px 16px' }}>
                                <FilterInput open={openIngoPage} className={classes.textLabel} value={filterInfoPage} onChangeValue={(e) => { setFilterInfoPage(e.target.value) }} name={'Info page'.toLowerCase()} />
                            </ListItem>
                            {/* <ListItem className={classes.boxBoder} style={{ padding: '16px' }} button onClick={() => pickInfoPage({ name: '' })}>
                                <Typography className={classes.TextValue}></Typography>
                            </ListItem> */}
                            {
                                infoPages.map((item, index) => (
                                    <ListItem key={'keyav_' + index} className={classes.boxBoder} style={{ padding: '8px 16px' }} button onClick={() => pickInfoPage(item)}>
                                        <Typography className={classes.TextValue}>{item.name}</Typography>
                                    </ListItem>
                                ))
                            }
                        </SelectBox>
                    </Box>
                    <Box>
                        <Box display='flex' px={3} py={2} mt={1} bgcolor={theme.palette.primary.main}>
                            <Box width={200}>
                                <Typography
                                    style={{ cursor: 'pointer', fontSize: 13 }}
                                    className={classes.TitleName}>
                                    {translate(`pos.remoteControl.button`)}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography
                                    style={{ cursor: 'pointer', fontSize: 13 }}
                                    className={classes.TitleName}>
                                    {translate(`pos.remoteControl.mapping`)}
                                </Typography>
                            </Box>
                        </Box>
                        {
                            nodeLoading ? <Loading /> :
                                keyData.map((keyItem, keyIndex) => (
                                    <Box key={'keyItem_' + keyIndex} display='flex' py={1}>
                                        <Box minWidth={200} display='flex' alignItems='center' pl={3}> <Typography
                                            color='primary'
                                            style={{ fontSize: 13 }}
                                            variant='body1'>
                                            <b>{`Key ${keyItem.name}`}</b>
                                        </Typography></Box>
                                        <Box width='100%'>
                                            <FormControl style={{ width: '100%' }}>
                                                <NativeSelect
                                                    id={`select_${keyIndex}`}
                                                    value={node[keyIndex]}
                                                    onChange={(e) => handleChange(e, keyIndex)}
                                                    input={<BootstrapInput />}
                                                >
                                                    <option aria-label="None" value={undefined} />
                                                    {
                                                        nodes.map((item, index) => (
                                                            <option key={'node_' + keyIndex + "_" + index} value={item.code}>{item.nodeName}</option>
                                                        ))
                                                    }

                                                </NativeSelect>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                ))

                        }
                    </Box>
                    <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                        <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/Remote" }} />
                           
                        <Button style={{ pading: 8 }} variant='contained' color='primary' onClick={onSave}>
                            {translate(`pos.common.save`)}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>

    )
}
export default KeyMap